module.exports = __webpack_public_path__ + "media/images/telegram-c6f797fe631a28d7a3f5f8035eeb2cd3.png";